import $$ from 'dom7';
import Framework7 from 'framework7/framework7.esm.bundle.js';

// Import F7 Styles
import 'framework7/css/framework7.bundle.css';

// Import Icons and App Custom Styles
import '../css/icons.css';
import '../css/font-awesome.min.css';
import '../css/app.css';
import '../css/locker.css';
// Import Cordova APIs
import cordovaApp from './cordova-app.js';
// Import Routes
import routes from './routes.js';

// Register service worker for PWA (must be HTTPS in production)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .catch(function (err) { console.warn('SW registration failed:', err); });
  });
}

var baseURL = "https://api.digitalmoneyexpress.com/v2/"; // Base URL for API requests, update this to your server URL
window.baseURL = baseURL; // expose for .f7.html component scripts (which don't share module scope)
// Reusable OTP resend cooldown — disables a resend link and counts down "Resend in Ns".
window.otpCooldown = function (el, seconds) {
  if (!el) return;
  seconds = seconds || 180;
  if (el.getAttribute('data-cd-base') == null) {
    el.setAttribute('data-cd-base', (el.textContent || 'Resend code').trim());
  }
  var base = el.getAttribute('data-cd-base');
  if (el._cdTimer) clearInterval(el._cdTimer);
  var left = seconds;
  var render = function () {
    if (left <= 0) {
      clearInterval(el._cdTimer); el._cdTimer = null;
      el.classList.remove('otp__resend--off');
      el.textContent = base;
      return;
    }
    el.classList.add('otp__resend--off');
    var mm = Math.floor(left / 60);
    var ss = left % 60;
    var time = mm > 0 ? (mm + ':' + (ss < 10 ? '0' : '') + ss) : (ss + 's');
    el.textContent = 'Resend in ' + time;
    left--;
  };
  render();
  el._cdTimer = setInterval(render, 1000);
};
// Start the resend cooldown for an OTP sheet (call right after the sheet is opened
// / a fresh code is sent). Scopes to the sheet so the correct .resendOTPac is used.
window.startOtpCooldown = function (sheetSelector, seconds) {
  var link = document.querySelector(sheetSelector + ' .resendOTPac');
  if (link) window.otpCooldown(link, seconds || 180);
};
// Shared live XAUt (gold) price cache. Every screen computes portfolio value as
// holdings × price; fetching CoinGecko independently on each page gave slightly
// different values (the price ticks between fetches). Route the fetched price
// through this: within TTL all callers reuse the SAME cached price, so the Home
// card and the Portfolio page always show an identical market value.
// Pass a freshly-fetched price to (maybe) refresh the cache; pass 0 to just read.
window.sharedGoldPrice = function (fresh) {
  var TTL = 60000, now = Date.now();
  var cp = parseFloat(localStorage.getItem('liveGoldPrice'));
  var ct = parseFloat(localStorage.getItem('liveGoldPriceAt'));
  var cacheValid = (cp > 0 && !isNaN(ct) && (now - ct) <= TTL);
  fresh = parseFloat(fresh);
  if (fresh > 0 && !cacheValid) {
    localStorage.setItem('liveGoldPrice', fresh);
    localStorage.setItem('liveGoldPriceAt', String(now));
    return fresh;
  }
  if (cacheValid) return cp;               // reuse cached → consistent across pages
  return fresh > 0 ? fresh : (cp > 0 ? cp : 0);
};
/* ─────────────────────────────── Plan 2.0 config ───────────────────────────────
   Every plan number (daily ROI, cap multiple, min/max invest, withdrawal fee,
   payout days, Team ROI cap) is admin-editable server-side, so NOTHING here may
   be hard-coded in the UI. This fetches `investmentPlans` from invest.php once,
   merges the `program` block from getSettings.php, and caches the result so the
   invest / withdraw / earning screens all render the same live values.

   Usage:  window.planConfig.get(function (cfg) { ... });
           window.planConfig.cached()          → last value or defaults
   The defaults below are last-resort fallbacks for a failed request only —
   they are NOT the source of truth. */
window.planConfig = (function () {
  var TTL = 5 * 60 * 1000;
  var cache = null, cachedAt = 0, inflight = null, waiting = [];
  // Fallbacks used only when both requests fail; keeps the UI rendering.
  var DEFAULTS = {
    plans: [],
    minInvest: 10,
    // Investment amounts must be a whole multiple of this. 0 disables the rule,
    // so treat "no step" and "step 0" as the same thing — never divide by it.
    investStep: 10,
    minWithdraw: 10,
    withdrawFeePct: 5,
    // ROI payout days and withdrawal-request days are TWO INDEPENDENT settings —
    // money can be credited on days a member may not request a payout, and vice versa.
    payoutDays: [1, 2, 3, 4, 5],
    payoutDaysLabel: 'Mon–Fri',
    withdrawDays: [1, 2, 3, 4, 5],
    withdrawDaysLabel: 'Mon–Fri',
    teamRoiCapMult: 5,
    directReferralEnabled: false,
    directReferralPct: 0,
    // Per-program switches — hide a program's UI entirely when its flag is false,
    // otherwise members see a section that will never pay them.
    warriorEnabled: true,
    warriorBasis: 'downline_roi',
    royaltyEnabled: true,
    royaltySplit: 'equal',
    rewardEnabled: true,
    // Leadership-salary rules the owner can switch off — don't assume they hold.
    salaryNoDowngrade: true,
    salaryMaintenance: true
  };
  function num(v, fb) { var n = parseFloat(v); return isNaN(n) ? fb : n; }
  // ISO-8601 weekday for a Date: 1 = Monday … 7 = Sunday (JS getDay() is 0 = Sunday).
  function isoDay(date) {
    var d = (date || new Date()).getDay();
    return d === 0 ? 7 : d;
  }
  function bool(v, fb) {
    if (v == null) return fb;
    return (v === true || v === 1 || v === '1' || String(v).toLowerCase() === 'true');
  }
  function normPlan(p) {
    var maxInvest = (p.maxInvest === '' || p.maxInvest == null) ? null : num(p.maxInvest, null);
    return {
      id: p.id,
      code: String(p.code || '').toUpperCase(),
      name: p.name || (p.code ? (p.code.charAt(0) + p.code.slice(1).toLowerCase() + ' Plan') : 'Plan'),
      dailyRoi: num(p.dailyRoi, 0),                 // percent, e.g. 0.50
      // capMultiple caps the TOTAL return, with the principal counted INSIDE it —
      // a $10 investment on a 2x plan returns $20 in total: $10 ROI + the $10 capital.
      // So the ROI itself only has to reach (capMultiple - 1) x principal.
      capMultiple: num(p.capMultiple, 2),
      maxReturnLabel: p.maxReturnLabel || (num(p.capMultiple, 2) + 'x Investment'),
      minInvest: num(p.minInvest, 10),
      maxInvest: maxInvest,                          // null = unlimited
      maxInvestLabel: p.maxInvestLabel || (maxInvest == null ? 'Unlimited' : ('$' + maxInvest)),
      roiWithdrawable: p.roiWithdrawable === true || p.roiWithdrawable == 1,
      principalLocked: p.principalLocked === true || p.principalLocked == 1,
      // Early-exit charge on principal taken out before the cycle completes.
      // 0 on every plan today, but switchable per plan at any time.
      principalFeePct: num(p.principalFeePct, 0),
      description: p.description || ''
    };
  }
  function resolve(cfg) {
    cache = cfg; cachedAt = Date.now(); inflight = null;
    var qs = waiting; waiting = [];
    qs.forEach(function (cb) { try { cb(cfg); } catch (e) {} });
  }
  function load() {
    var cfg = {};
    for (var k in DEFAULTS) cfg[k] = DEFAULTS[k];
    var pending = 2;
    function done() { if (--pending === 0) resolve(cfg); }

    $.post(baseURL + 'invest.php',
      { investmentPlans: 1, token: localStorage.getItem('authToken') }, null, 'json')
      .done(function (res) {
        if (res && res.status === 'success') {
          if (Object.prototype.toString.call(res.plans) === '[object Array]') {
            cfg.plans = res.plans.map(normPlan);
          }
          cfg.minWithdraw = num(res.minWithdraw, cfg.minWithdraw);
          cfg.withdrawFeePct = num(res.withdrawFeePct, cfg.withdrawFeePct);
          if (Object.prototype.toString.call(res.payoutDays) === '[object Array]' && res.payoutDays.length) {
            cfg.payoutDays = res.payoutDays.map(Number);
          }
          if (res.payoutDaysLabel) cfg.payoutDaysLabel = res.payoutDaysLabel;
          if (Object.prototype.toString.call(res.withdrawDays) === '[object Array]' && res.withdrawDays.length) {
            cfg.withdrawDays = res.withdrawDays.map(Number);
          }
          if (res.withdrawDaysLabel) cfg.withdrawDaysLabel = res.withdrawDaysLabel;
          // Cheapest plan floor doubles as the global minimum investment.
          if (cfg.plans.length) {
            cfg.minInvest = cfg.plans.reduce(function (m, p) { return Math.min(m, p.minInvest); }, Infinity);
          }
        }
      })
      .always(done);

    $.getJSON(baseURL + 'getSettings.php')
      .done(function (d) {
        var pr = (d && d.program) || {};
        cfg.teamRoiCapMult = num(pr.team_roi_cap_mult, cfg.teamRoiCapMult);
        cfg.directReferralEnabled = (pr.direct_referral_enabled === true || pr.direct_referral_enabled == 1);
        cfg.directReferralPct = cfg.directReferralEnabled ? num(pr.direct_referral_pct, 0) : 0;
        if (Object.prototype.toString.call(pr.payout_days) === '[object Array]' && pr.payout_days.length) {
          cfg.payoutDays = pr.payout_days.map(Number);
        }
        if (Object.prototype.toString.call(pr.withdraw_days) === '[object Array]' && pr.withdraw_days.length) {
          cfg.withdrawDays = pr.withdraw_days.map(Number);
        }
        // Per-program on/off switches and the two leadership-salary rule flags.
        cfg.warriorEnabled = bool(pr.warrior_enabled, cfg.warriorEnabled);
        cfg.warriorBasis = pr.warrior_basis || cfg.warriorBasis;
        cfg.royaltyEnabled = bool(pr.royalty_enabled, cfg.royaltyEnabled);
        cfg.royaltySplit = pr.royalty_split || cfg.royaltySplit;
        cfg.rewardEnabled = bool(pr.reward_enabled, cfg.rewardEnabled);
        cfg.salaryNoDowngrade = bool(pr.salary_no_downgrade, cfg.salaryNoDowngrade);
        cfg.salaryMaintenance = bool(pr.salary_maintenance, cfg.salaryMaintenance);
        cfg.investStep = Math.max(0, num(pr.invest_step, cfg.investStep));
        // invest.php is authoritative for these; only fill gaps from getSettings.php.
        cfg.minWithdraw = num(pr.min_withdraw, cfg.minWithdraw);
        if (pr.withdraw_fee_pct != null) cfg.withdrawFeePct = num(pr.withdraw_fee_pct, cfg.withdrawFeePct);
      })
      .always(done);
  }
  return {
    get: function (cb) {
      if (cache && (Date.now() - cachedAt) <= TTL) { cb(cache); return; }
      waiting.push(cb);
      if (!inflight) { inflight = true; load(); }
    },
    cached: function () { return cache || DEFAULTS; },
    // Find a plan by code or numeric id; null when unknown.
    plan: function (key) {
      var list = (cache || DEFAULTS).plans, k = String(key || '').toUpperCase();
      for (var i = 0; i < list.length; i++) {
        if (list[i].code === k || String(list[i].id) === String(key)) return list[i];
      }
      return null;
    },
    // Is `date` (default today) a ROI payout day? ISO-8601: 1 = Monday … 7 = Sunday.
    isPayoutDay: function (date) {
      return (cache || DEFAULTS).payoutDays.indexOf(isoDay(date)) !== -1;
    },
    // Can a withdrawal be REQUESTED today? Independent of isPayoutDay.
    isWithdrawDay: function (date) {
      return (cache || DEFAULTS).withdrawDays.indexOf(isoDay(date)) !== -1;
    },
    invalidate: function () { cache = null; cachedAt = 0; }
  };
})();

const app_ver = '1.0.5'; // App version, update this for new releases
// What's New changelog — add a new entry (newest first) each release.
// Each item: { icon: 'wallet|user|zap|rocket', text: '<b>bold</b> supported', soon: true (teaser) }
const app_changelog = {
  '1.0.5': [
    { icon: 'rocket', text: 'Three new investment plans — <b>Silver, Gold &amp; Diamond</b>. Pick your daily ROI and return cap when you invest.' },
    { icon: 'zap',    text: 'The <b>365-day lock-in is gone</b> — investments simply run until your total return reaches the plan cap, <b>2× your investment</b>.' },
    { icon: 'wallet', text: 'New <b>capital return</b> — withdraw your principal separately, with any early-exit charge shown before you confirm. The processing fee is down to <b>5%</b>.' },
    { icon: 'chart',  text: 'Three new income programs: <b>Express Warrior</b>, <b>Royalty Income</b> and <b>One-Time Rewards</b>, plus a rebuilt Leadership Salary panel.' },
  ],
  '1.0.4': [
    { icon: 'chart',  text: 'A live <b>crypto price ticker</b> on your dashboard — watch BTC, ETH, XAUt and more update in real time.' },
    { icon: 'wallet', text: 'Withdrawals now show the <b>BEP-20 wallets we support</b> — Trust Wallet, MetaMask, SafePal, Binance and more.' },
    { icon: 'zap',    text: 'A more accurate <b>portfolio value</b> that stays consistent across screens, plus design refinements and bug fixes.' },
  ]
};
const WN_ICONS = {
  wallet: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2.5"/><path d="M16 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0z" fill="currentColor" stroke="none"/><line x1="2" y1="9.5" x2="22" y2="9.5"/></svg>',
  user:   '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>',
  zap:    '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
  chart:  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>',
  receipt:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>',
  bell:   '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>',
  rocket: '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/><path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/><path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/></svg>'
};
// Show the "What's New" popup. Pass force=true to open it manually (e.g. from About).
// Auto mode: silent on a fresh install, shown once after a version upgrade.
window.showWhatsNew = function (force) {
  var seen = localStorage.getItem('seenAppVersion');
  if (!force) {
    if (!seen) { localStorage.setItem('seenAppVersion', app_ver); return; } // first install
    if (seen === app_ver) return;                                           // already seen this version
  }
  var logs = app_changelog[app_ver] || [];
  if (!logs.length) { localStorage.setItem('seenAppVersion', app_ver); return; }
  var html = '';
  logs.forEach(function (it) {
    var o = (typeof it === 'string') ? { text: it } : it;
    var soon = !!o.soon;
    var icon = WN_ICONS[o.icon] || WN_ICONS[soon ? 'rocket' : 'zap'];
    html += '<li class="wn__item' + (soon ? ' wn__item--soon' : '') + '">' +
      '<span class="wn__ico wn__ico--' + (soon ? 'soon' : 'done') + '">' + icon + '</span>' +
      '<span class="wn__text">' + o.text +
        (soon ? '<span class="wn__soon-badge">Coming soon</span>' : '') +
      '</span>' +
    '</li>';
  });
  $$('.wn__version').html('v' + app_ver);
  $$('.wn__list').html(html);
  app.popup.open('#whatsnew-popup');
  localStorage.setItem('seenAppVersion', app_ver);
};
const environment = 'production'; // Set to 'production' for live environment, 'development' for testing
var app = new Framework7({
  root: '#app', // App root element
  id: 'app.digimoneyexpress.com', // App bundle ID
  name: 'Digi Money Express', // App name
  theme: 'md', // Automatic theme detection
  //app pushstate
  view: {
    pushState: true,
    pushStateSeparator: '#!',
    pushStateOnLoad: true,
    preloadPreviousPage: false,
  },
  smartSelect: {
    closeOnSelect: true,
  },
  sheet: {
    closeByBackdropClick: false
  },
  // App root methods
  methods: {
    initImageUpload: function(box) {
      let uploadField = box.querySelector('.image-upload');
        
        uploadField.addEventListener('change', getFile);
      
        function getFile(e){
          let file = e.currentTarget.files[0];
          checkType(file);
        }
        
        function previewImage(file){
          let thumb = box.querySelector('.js--image-preview'),
              reader = new FileReader();
      
          reader.onload = function() {
            thumb.style.backgroundImage = 'url(' + reader.result + ')';
          }
          reader.readAsDataURL(file);
          thumb.className += ' js--no-default';
        }
      
        function checkType(file){
          let imageType = /image.*/;
          //var size=(file.size)/1000;
          if (!file.type.match(imageType)) {
            app.toast.show({
              text: 'This is not an Image!',
              closeTimeout: 3000,
            });
            throw 'This is not an image';
          } else if (!file){
            app.toast.show({
              text: 'No file found!',
              closeTimeout: 3000,
            });
            throw 'No file found';
          } else {
            previewImage(file);
          }
        }
    },
    initDropEffect: function(box) {
      let area, drop, areaWidth, areaHeight, maxDistance, dropWidth, dropHeight, x, y;
          
      // get clickable area for drop effect
      area = box.querySelector('.js--image-preview');
      area.addEventListener('click', fireRipple);
      
      function fireRipple(e){
        area = e.currentTarget
        // create drop
        if(!drop){
          drop = document.createElement('span');
          drop.className = 'drop';
          this.appendChild(drop);
        }
        // reset animate class
        drop.className = 'drop';
        
        // calculate dimensions of area (longest side)
        areaWidth = getComputedStyle(this, null).getPropertyValue("width");
        areaHeight = getComputedStyle(this, null).getPropertyValue("height");
        maxDistance = Math.max(parseInt(areaWidth, 10), parseInt(areaHeight, 10));
    
        // set drop dimensions to fill area
        drop.style.width = maxDistance + 'px';
        drop.style.height = maxDistance + 'px';
        
        // calculate dimensions of drop
        dropWidth = getComputedStyle(this, null).getPropertyValue("width");
        dropHeight = getComputedStyle(this, null).getPropertyValue("height");
        
        // calculate relative coordinates of click
        // logic: click coordinates relative to page - parent's position relative to page - half of self height/width to make it controllable from the center
        x = e.pageX - this.offsetLeft - (parseInt(dropWidth, 10)/2);
        y = e.pageY - this.offsetTop - (parseInt(dropHeight, 10)/2) - 30;
        
        // position drop and animate
        drop.style.top = y + 'px';
        drop.style.left = x + 'px';
        drop.className += ' animate';
        e.stopPropagation();
        
      }
    },
    initFileUpload: function() {
      var inputs = document.querySelectorAll( '.inputfile' );
        Array.prototype.forEach.call( inputs, function( input )
        {
          var label	 = input.nextElementSibling,
            labelVal = label.innerHTML;

          input.addEventListener( 'change', function( e )
          {
            var fileName = '';
            if( this.files && this.files.length > 1 )
              fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
            else
              fileName = e.target.value.split( '\\' ).pop();

            if( fileName )
              label.querySelector( 'span' ).innerHTML = fileName;
            else
              label.innerHTML = labelVal;
          });
        });
    },
    getPIN: function(pincode, success, error) {
      var settings = {
        "async": true,
        "crossDomain": true,
        "url": "https://pincode.p.rapidapi.com/",
        "method": "POST",
        "headers": {
          "x-rapidapi-host": "pincode.p.rapidapi.com",
          "x-rapidapi-key": "d52c228c20msh28eb4e495fba18ep1836f6jsn44bce943016f",
          "content-type": "application/json",
          "accept": "application/json"
        },
        "processData": false,
        "data": "{\"searchBy\":\"pincode\",\"value\":"+pincode+"}"
      }
      
      $.ajax(settings).done(function (response) {
        if(response.length === 0) {
          error("no places found");
        }
        else {
          success(response);
        }
      });
    },
    getJSON: function( url, callback) {
      $.getJSON(url, function(data) {
        callback(data);
      });
    },
    request: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    post: function( url, data, datatype, beforesend, success, error) {
      $.ajax({
        url: url,
        data: data,
        cache: false,
        dataType: datatype,
        type: 'POST',
        mimeType: "multipart/form-data",
        contentType: false,
        processData: false,
        crossDomain : true,
        beforeSend: function() {
          beforesend();
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getUserData: function(success, error) {
      $.ajax({
        url: baseURL+'ajaxAuthentication.php',
        data: {userinfo: true, token: localStorage.getItem('authToken'), 'uuid': localStorage.getItem('uuid')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getUserDataInvest: function(success, error) {
      $.ajax({
        url: baseURL+'invest.php',
        data: {investInfo: true, token: localStorage.getItem('authToken')},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {
        },
        success: function(_response){
          success(_response);
        },
        error: function(_error){
        }
      });
    },
    getBank: function(success, error) {
      $.ajax({
        url: baseURL+'ajaxAuthentication.php',
        data: {getbank: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    getSettings: function(success, error) {
      $.ajax({
        url: baseURL+'ajaxAuthentication.php',
        data: {getSettings: true},
        cache: false,
        dataType: 'json',
        type: 'POST',
        crossDomain : true,
        beforeSend: function() {},
        success: function(_response){
          success(_response);
        },
        error: function(_error){
          error(_error);
        }
      });
    },
    random_color: function() {
      var letters = '0123456789ABCDEF';
      var color = '';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    addComma: function(x) {
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  // App routes
  routes: routes,
  // Input settings
  input: {
    scrollIntoViewOnFocus: Framework7.device.cordova && !Framework7.device.electron,
    scrollIntoViewCentered: Framework7.device.cordova && !Framework7.device.electron,
  },
  // Cordova Statusbar settings
  statusbar: {
    overlay: Framework7.device.cordova && Framework7.device.ios || 'auto',
    iosOverlaysWebView: true,
    androidOverlaysWebView: false,
  },
  on: {
    init: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
      }
    },
    //APP PAGE INIT
    pageInit: function () {
      var f7 = this;
      if (f7.device.cordova) {
        // Init cordova APIs (see cordova-app.js)
        cordovaApp.init(f7);
        //push notifications
        document.addEventListener('deviceready', OneSignalInit, false);
        function OneSignalInit() {
            // Uncomment to set OneSignal device logging to VERBOSE  
            // window.plugins.OneSignal.setLogLevel(6, 0);
            
            // NOTE: Update the setAppId value below with your OneSignal AppId.
            window.plugins.OneSignal.setAppId("99ff4514-ef4f-488b-b853-942b3209e23b");
            window.plugins.OneSignal.setNotificationOpenedHandler(function(jsonData) {
              console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData));
            });
            //Prompts the user for notification permissions.
              //    * Since this shows a generic native prompt, we recommend instead using an In-App Message to prompt for notification permission (See step 6) to better communicate to your users what notifications they will get.
              window.plugins.OneSignal.promptForPushNotificationsWithUserResponse(function(accepted) {
                console.log("User accepted notifications: " + accepted);
            });
            var deviceID = device.uuid;
            window.plugins.OneSignal.setExternalUserId(deviceID);
            localStorage.setItem('uuid', deviceID);
            //console.log(deviceID);
        }
      }
      // Desktop / DevTools protection (production only)
      if (environment == 'production') {
        // 1) Activate the desktop / large-screen guard overlay (static markup in
        //    index.html). Visibility is driven by CSS (body.is-prod .dtg + @media
        //    + body.is-desktop), so it stays responsive without destroying the
        //    page or reloading.
        document.body.classList.add('is-prod');
        // Flag genuine desktop devices (no touch) so the guard also shows on a
        // small desktop window, not just wide viewports.
        var isTouch = ('ontouchstart' in window) || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        if (!isTouch) document.body.classList.add('is-desktop');

        // Build the "scan to open on mobile" QR from the current URL (once).
        // Encodes the live deployment URL (minus the F7 #! route) so the phone
        // opens the same app. Hides the QR block gracefully if the image fails.
        if (!window.__dtgQrInit) {
          window.__dtgQrInit = true;
          var qrImg = document.getElementById('dtg-qr-img');
          if (qrImg) {
            var qrTarget = location.href.replace(/#.*$/, '');
            qrImg.onerror = function () { var w = document.querySelector('.dtg__qr'); if (w) w.style.display = 'none'; };
            qrImg.src = 'https://api.qrserver.com/v1/create-qr-code/?size=300x300&qzone=2&ecc=M&data=' + encodeURIComponent(qrTarget);
          }
        }

        // 2) Deter DevTools — bound once (this pageInit runs on every navigation).
        //    Note: these are deterrents only; they cannot truly prevent inspection.
        if (!window.__devGuardInit) {
          window.__devGuardInit = true;
          document.addEventListener('keydown', function (event) {
            var k = event.keyCode || event.which;
            var ctrl = event.ctrlKey || event.metaKey;
            if (
              k === 123 ||                                            // F12
              (ctrl && event.shiftKey && (k === 73 || k === 74 || k === 67)) || // Ctrl/Cmd+Shift+I / J / C
              (ctrl && k === 85)                                      // Ctrl+U (view source)
            ) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          }, true);
          document.addEventListener('contextmenu', function (e) { e.preventDefault(); }, true);
        }
      }
      checkMaintenance();
      // Poll the settings flag on every pageInit. Once the overlay is up we stop
      // polling — the retry button (or a reload) is what brings the app back.
      function checkMaintenance() {
        if (window.__mtnActive) return;
        $.getJSON(baseURL+'getSettings.php', function(data) {
          if (data && data.maintenance) showMaintenance(data.maintenance_message);
        });
      }
      // Render a full-screen overlay on top of the app instead of emptying
      // .page-content: the F7 chrome (navbar, toolbar, panels, the Digi Coin
      // floating token) is hidden by body.is-maintenance, so nothing has to be
      // rebuilt when maintenance ends — we just reload.
      function showMaintenance(message) {
        window.__mtnActive = true;
        $$('body').addClass('is-maintenance');

        if (!$$('#mtn-screen').length) {
          $$('body').append(
            '<div id="mtn-screen" class="mtn">'+
              '<span class="mtn__orb mtn__orb--1"></span>'+
              '<span class="mtn__orb mtn__orb--2"></span>'+
              '<div class="mtn__inner">'+

                '<img class="mtn__brand-logo" src="assets/icons/icon_wide.png" alt="Digi Money Express" />'+

                '<div class="mtn__emblem">'+
                  '<span class="mtn__emblem-pulse"></span>'+
                  '<span class="mtn__emblem-pulse mtn__emblem-pulse--2"></span>'+
                  '<span class="mtn__emblem-dial"></span>'+
                  '<span class="mtn__emblem-arc"></span>'+
                  '<span class="mtn__emblem-core">'+
                    '<svg class="mtn__gear" width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>'+
                  '</span>'+
                  '<svg class="mtn__gear--sm" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3.5"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1"/></svg>'+
                '</div>'+

                '<h2 class="mtn__title">Under Maintenance</h2>'+
                '<div class="mtn__rule"></div>'+
                '<p class="mtn__msg"></p>'+

                '<div class="mtn__bar"><span class="mtn__bar-fill"></span></div>'+

                '<div class="mtn__card">'+
                  '<span class="mtn__card-ico">'+
                    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>'+
                  '</span>'+
                  '<span class="mtn__card-txt">'+
                    '<span class="mtn__card-lbl"><span class="mtn__dot"></span>Back shortly</span>'+
                    '<span class="mtn__card-sub">Your funds and account are safe. Thank you for your patience.</span>'+
                  '</span>'+
                '</div>'+

                '<a href="#" class="mtn__retry">'+
                  '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>'+
                  '<span>Check again</span>'+
                '</a>'+

                '<div class="mtn__foot">Version '+app_ver+'</div>'+
              '</div>'+
            '</div>'
          );

          // Re-check on demand: reload the moment the flag is cleared, otherwise
          // release the button so the user can try again.
          $$('#mtn-screen').find('.mtn__retry').on('click', function (e) {
            e.preventDefault();
            var $btn = $$(this);
            if ($btn.hasClass('mtn__retry--busy')) return;
            $btn.addClass('mtn__retry--busy');
            var release = function () {
              setTimeout(function () { $btn.removeClass('mtn__retry--busy'); }, 700);
            };
            $.getJSON(baseURL+'getSettings.php', function (data) {
              if (data && !data.maintenance) { window.location.reload(); return; }
              release();
            }).fail(release);
          });
        }

        $$('#mtn-screen').find('.mtn__msg').html(
          message || 'We are currently performing scheduled maintenance to improve your experience.'
        );
      }
      //app version
      $$('.app-version').html(app_ver);
      // Fill the global plan-driven placeholders (Referral & Rewards popup, etc.) with
      // live values. planConfig caches, so this is one request per session, not per page.
      if (window.planConfig) {
        window.planConfig.get(function (cfg) {
          function usd(n) { return '$' + Number(n).toLocaleString('en-US', { maximumFractionDigits: 2 }); }
          function mult(n) { return String(parseFloat(Number(n).toFixed(2))) + '×'; }
          function range(vals, fmt) {
            if (!vals.length) return '—';
            var lo = Math.min.apply(null, vals), hi = Math.max.apply(null, vals);
            return lo === hi ? fmt(lo) : (fmt(lo) + ' – ' + fmt(hi));
          }
          var plans = cfg.plans || [];
          $$('.rf-roi-range').html(range(plans.map(function (p) { return p.dailyRoi; }), function (v) { return v.toFixed(2) + '%'; }));
          $$('.rf-cap-range').html(range(plans.map(function (p) { return p.capMultiple; }), mult));
          $$('.rf-min-invest').html(plans.length ? usd(cfg.minInvest) : '—');
          $$('.rf-min-withdraw').html(usd(cfg.minWithdraw));
          $$('.rf-fee-pct').html(cfg.withdrawFeePct + '%');
          $$('.rf-payout-days').html(cfg.payoutDaysLabel);
          $$('.rf-withdraw-days').html(cfg.withdrawDaysLabel);
          $$('.rf-troi-cap').html(mult(cfg.teamRoiCapMult));
          $$('.rf-troi-range').html('Up to ' + mult(cfg.teamRoiCapMult) + ' cap');
          // The direct referral bonus is an admin switch — hide its UI while it is off.
          $$('.referral-bonus-promo').css('display', cfg.directReferralEnabled ? '' : 'none');
        });
      }
      // Show "What's New" once after an app update (guard: only attempt once per session)
      if (!window.__whatsNewChecked) {
        window.__whatsNewChecked = true;
        setTimeout(function () { try { window.showWhatsNew(); } catch (e) {} }, 1200);
      }
      // Open the update log manually from the About page.
      // Close the About popup first — opening a popup stacked over another can fail to render.
      $$('.wn-open').off('click',).on('click', function (e) {});
      $$('.wn-open').on('click', function (e) {
        console.log('Open changelog');
        e.preventDefault();
        var openOver = $$('.popup.modal-in').length > 0;
        if (openOver) app.popup.close();
        setTimeout(function () { window.showWhatsNew(true); }, openOver ? 320 : 0);
      });
      //check if user is terminated
      f7.methods.getUserData(function(data) {
        if(data.status == 'blocked') {
          app.views.current.router.navigate({name: 'Home'});
          localStorage.removeItem('authToken');
          localStorage.removeItem('phone');
          localStorage.removeItem('isloggedIN');
          localStorage.removeItem('payment');
          app.popup.close('#profile-popup');
          $$('.login-link').attr('href','/login/');
          $$('.login-link').removeClass('logout');
          $$('.login-link').html('Login');
          $$('.profile-link').attr('href','/login/');
          $$('.profile-link').removeClass('popup-open');
          $$('.profile-link').removeAttr('data-popup');
          f7.toast.show({
            text: 'Your account is terminated and logged out from this device!',
            closeTimeout: 3000,
          });
        }
      });
      //logout
      $$(document).off('click', '.logout');
      $$(document).on('click', '.logout' ,function() {
        localStorage.removeItem('authToken');
        localStorage.removeItem('phone');
        localStorage.removeItem('isloggedIN');
        app.popup.close('#profile-popup');
        var router = app.views.current.router;
        router.navigate(router.currentRoute.url, {
          reloadCurrent: true,
          ignoreCache: true,
        });
        $$('.profile-link').attr('href','/login/');
        $$('.profile-link').removeClass('popup-open');
        $$('.profile-link').removeAttr('data-popup');
        f7.toast.show({
          text: 'Logged out from this device!',
          closeTimeout: 3000,
        });
      })
      // NOTE: a document-delegated `popup:open` handler can't be used here —
      // dom7 2.1.3 has no event namespaces (so `popup:open.otpcd` never fires),
      // and the profile-popup handler below does `.off('popup:open', ...)` which
      // wipes ALL delegated popup:open listeners. Instead the cooldown is started
      // explicitly wherever an OTP sheet is opened, via window.startOtpCooldown().
      // Populate profile popup whenever it opens, from any page
      $$(document).off('popup:open', '#profile-popup').on('popup:open', '#profile-popup', function() {
        f7.methods.getUserData(function(data) {
          if (data.isLoggedin != 'true') return;
          if (data.referralCode) {
            $$('.referral-code').html(data.referralCode);
            $$('.invite-link-btn').attr('data-referral', data.referralCode);
          }
          $$('.profile-name').html(data.name);
          $$('.loggeninProfileUI').attr('src', 'https://ui-avatars.com/api/?background=201a0e&color=dfc288&length=2&rounded=true&bold=true&font-size=0.42&name=' + encodeURIComponent(data.name));
          $$('.profile-username').html(data.username || '—');
          $$('.profile-email').html(data.email);
          $$('.profile-phone').html(data.phone);
          $$('.profile-dob').html(data.dob);
          $$('.profile-country').html(data.country || '—');
          $$('.profile-dialcode').html(data.dialCode || data.dial_code || data.countryCode || data.phonecode || '—');
          // KYC status pill in the profile popup — DISABLED for now (KYC feature hidden)
          /*
          f7.methods.request(baseURL + 'kyc.php', { kycStatus: 1, token: localStorage.getItem('authToken') }, 'json',
            function() {},
            function(res) {
              if (!res || res.status !== 'success') return;
              var st = res.kycStatus === 'not_submitted' ? 'none' : (res.kycStatus || 'none');
              var map = {
                approved: { txt: 'Verified',     sub: 'Your identity is verified — withdrawals enabled' },
                pending:  { txt: 'Under review', sub: 'Your documents are being reviewed' },
                rejected: { txt: 'Rejected',     sub: 'Verification failed — tap to resubmit' },
                none:     { txt: 'Not started',  sub: 'Verify your identity to enable withdrawals' }
              };
              var m = map[st] || map.none;
              $$('.pp__kyc-status').removeClass('pp__kyc-status--approved pp__kyc-status--pending pp__kyc-status--rejected pp__kyc-status--none').addClass('pp__kyc-status--' + st);
              $$('.pp__kyc-status-txt').html(m.txt);
              $$('.pp__kyc-sub--text').html(m.sub);
            },
            function() {});
          */
        });
      });

      //OTP verification
      $(document).off('click', '.acBTNotp');
      $(document).on('click','.acBTNotp',function(){
        if (!$$('#ac-otp')[0].checkValidity()) {
          console.log('Check Validity!');
        } else {
          OTPverification();
        }
      });
      function OTPverification() {
        var value = $$('#ac-otp').val();
        app.methods.request(
          baseURL+'ajaxAuthentication.php',
          {OTPver: true, mobile: localStorage.getItem('phone'), OTP: value},
          'json',
          function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
          function(data) {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            if(data.status == 'success') {
              app.toast.show({
                text: 'Logged in successfully!',
                closeTimeout: 3000,
              });
              app.popup.close('.sheet-OTP--verification');
              localStorage.setItem('authToken', data.token);
              localStorage.setItem('isloggedIN', true);
              localStorage.setItem('country', data.country);
              localStorage.removeItem('phone');
              setTimeout(() => {
                var view = app.views.current;
                view.router.navigate('/');
                app.dialog.close();
              }, 1000);
            }
            else {
              app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
            }
          },
          function() {
            $$('.button').removeClass('disabled');
            app.dialog.close();
            app.toast.show({
                  text: 'No internet connection!',
                  closeTimeout: 3000,
                });
          }
        );
      }
      //resend otp
      $(document).off('click', '.resendOTPac');
      $(document).on('click', '.resendOTPac', function() {
        if (this.classList.contains('otp__resend--off')) return; // on cooldown
        var type = $$(this).data('type');
          if(type == 'account') {
            var phone = localStorage.getItem('phone');
          } else if(type == 'forgetpass') {
            var phone = $$('#fp-username').val();
          } else {

          }
        window.otpCooldown(this, 180); // start cooldown on this resend link
        app.methods.request(baseURL+'ajaxAuthentication.php',
        {OTPresend: true, phone: phone, type: type},
        'json',
        function() {app.dialog.progress('Loading...'); $$('.button').addClass('disabled');},
        function(data) {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          if(data.status == 'success') {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
          else {
            app.toast.show({
                  text: data.msg,
                  closeTimeout: 3000,
                });
          }
        },
        function() {
          $$('.button').removeClass('disabled');
          app.dialog.close();
          app.toast.show({
            text: 'Failed to Connect',
            closeTimeout: 3000,
          });
        }
        );
      });
    },
  },
});

/* ── Fix: F7 (pushState) doesn't auto-close modals on programmatic navigation ──
   When a popup/sheet is open and code redirects to another page, F7 leaves the
   modal + its backdrop stacked over the new page (untappable), so the redirect
   appears to "not work". Close any open modal and clear an orphaned backdrop on
   every route change. No-op when nothing is open, so it's safe globally. */
app.on('routeChange', function () {
  if (app.$('.popup.modal-in').length)         app.popup.close('.popup.modal-in', false);
  if (app.$('.sheet-modal.modal-in').length)   app.sheet.close('.sheet-modal.modal-in', false);
  if (app.$('.actions-modal.modal-in').length) app.actions.close('.actions-modal.modal-in', false);
  // safety net: drop any leftover backdrop that would block taps on the new page
  app.$('.modal-backdrop.backdrop-in, .sheet-backdrop.backdrop-in').removeClass('backdrop-in');
});

/* PWA services worker register */
// Register the service worker only in a real browser PWA context (secure origin),
// not inside the Cordova WebView (file://) where it can't register.
if ("serviceWorker" in navigator &&
    (location.protocol === "https:" || location.hostname === "localhost" || location.hostname === "127.0.0.1")) {
  window.addEventListener("load", function () {
      // Served from the ROOT → scope defaults to "/" (controls the whole app).
      navigator.serviceWorker
          .register("/service-worker.js")
          .then(function (reg) {
              console.log("service worker registered, scope:", reg.scope);
          })
          .catch(function (err) {
              console.log("service worker not registered", err);
          });
  });
}
/* PWA add to home button */
var defferedPrompt;
// Modern install sheet modal (replaces the old tiny-button notification)
var pwaInstallSheet = app.sheet.create({
    el: '#pwa-install-sheet',
    swipeToClose: true,
    on: {
      closed: function () {
        localStorage.setItem('pwaPromptDismissed', JSON.stringify({
          dismissed: true,
          time: new Date().toLocaleString(),
        }));
        console.log('PWA prompt dismissed');
      },
    },
});
// Install button → trigger the native A2HS prompt
$(document).off('click', '#install-pwa').on('click', '#install-pwa', function () {
    if (defferedPrompt) {
        defferedPrompt.prompt();
        defferedPrompt.userChoice.then(function (choiceResult) {
            console.log(choiceResult.outcome === 'accepted' ? 'User accepted the A2HS prompt' : 'User dismissed the A2HS prompt');
            defferedPrompt = null;
        });
    }
    pwaInstallSheet.close();
});
// Check if the app is already installed
function isAppInstalled() {
  return window.matchMedia('(display-mode: standalone)').matches || 
          window.navigator.standalone ||
          document.referrer.includes('android-app://');
}

// Check if user has previously dismissed the prompt
function hasDismissedPrompt() {
  //check if it's dismissed 1 hour ago
  const pwaPromptDismissed = localStorage.getItem('pwaPromptDismissed');
  if (pwaPromptDismissed) {
    const { dismissed, time } = JSON.parse(pwaPromptDismissed);
    if (dismissed) {
      const dismissedTime = new Date(time);
      const currentTime = new Date();
      const oneHour = 60 * 60 * 1000; // 1 hour in milliseconds
      // Check if the prompt was dismissed more than 1 hour ago
      if (currentTime - dismissedTime > oneHour) {
        // If more than 1 hour has passed, allow the prompt to be shown again
        localStorage.removeItem('pwaPromptDismissed');
        return false;
      }
      // If less than 1 hour has passed, do not show the prompt again
      return true;
    } else {
      return false;
    }
  }
  return false;
}
// Check if app is already installed on page load
if (isAppInstalled()) {
    console.log('App is already installed');
}
window.addEventListener("beforeinstallprompt", function (event) {
    event.preventDefault();
    defferedPrompt = event;
    console.log("beforeinstallprompt fired");
    // Show the modern install sheet (button click handled globally above)
    if(!hasDismissedPrompt() && !isAppInstalled()) {
      pwaInstallSheet.open();
    } else {
      console.log('PWA prompt dismissed or app already installed');
    }
});

window.addEventListener("appinstalled", function (event) {
    console.log("app installed");
    defferedPrompt = null;
    if (pwaInstallSheet) pwaInstallSheet.close();
    console.log("app installed", event);
});
